import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { PeriodEndPicker, PeriodPickerProps } from '../../components';
import { getDayjs, ISO_DATE_FORMAT, ISODate } from '../../utils';
import { Dayjs } from 'dayjs';
import { FORM_DATE_PICKER_POPUP_CLASSNAME } from './constants';

export interface FormPeriodPickerProps
  extends Omit<PeriodPickerProps, 'onChange' | 'value'> {
  name: string;
  onChange?: (val: Dayjs | null) => void;
}

export const FormPeriodEndPicker: React.FC<FormPeriodPickerProps> = (props) => {
  const { control } = useFormContext();
  const onChangeExtra = props.onChange;
  return (
    <Controller
      control={control}
      name={props.name}
      render={({ field: { value, onChange } }) => (
        <PeriodEndPicker
          {...props}
          value={value ? getDayjs(value, ISO_DATE_FORMAT) : null}
          onChange={(value) => {
            const isoDate = value
              ? (value.format(ISO_DATE_FORMAT) as ISODate)
              : null;
            onChange(isoDate);
            onChangeExtra?.(value);
          }}
          classNames={{
            popup: { root: FORM_DATE_PICKER_POPUP_CLASSNAME },
          }}
        />
      )}
    />
  );
};
